module.exports = __webpack_public_path__ + "static/media/21ECLAC11.ba8f878e.jpg";